import {
  GET_DELEGATED_OVERTIME_REQUESTS_ERROR,
  GET_DELEGATED_OVERTIME_REQUESTS_PENDING,
  GET_DELEGATED_OVERTIME_REQUESTS_SUCCESS,
  GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_ERROR,
  GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_PENDING,
  GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_SUCCESS,
  SET_DELEGATED_DROPDOWN_FILTER_COUNTRY,
  SET_DELEGATED_OVERTIME_REQUESTS,
  SET_DELEGATED_TIME_ADJUSTMENT_REQUESTS,
} from './constants';

const INIT_STATE = {
  overTimeDelegatedRequests: [],
  timeAdjustmentDelegatedRequests: [],
  isGetOverTimeDelegatedRequests: false,
  isGetTimeAdjustmentDelegatedRequests: false,
  selectedCountry: {},
};

export default (localState = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DELEGATED_OVERTIME_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetOverTimeDelegatedRequests: true,
      };
    }
    case GET_DELEGATED_OVERTIME_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetOverTimeDelegatedRequests: false,
      };
    }
    case GET_DELEGATED_OVERTIME_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetOverTimeDelegatedRequests: false,
      };
    }
    case SET_DELEGATED_OVERTIME_REQUESTS: {
      return {
        ...localState,
        overTimeDelegatedRequests: action.payload,
      };
    }
    case GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_PENDING: {
      return {
        ...localState,
        isGetTimeAdjustmentDelegatedRequests: true,
      };
    }
    case GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_SUCCESS: {
      return {
        ...localState,
        isGetTimeAdjustmentDelegatedRequests: false,
      };
    }
    case GET_DELEGATED_TIME_ADJUSTMENT_REQUESTS_ERROR: {
      return {
        ...localState,
        isGetTimeAdjustmentDelegatedRequests: false,
      };
    }
    case SET_DELEGATED_TIME_ADJUSTMENT_REQUESTS: {
      return {
        ...localState,
        timeAdjustmentDelegatedRequests: action.payload,
      };
    }
    case SET_DELEGATED_DROPDOWN_FILTER_COUNTRY: {
      return {
        ...localState,
        selectedCountry: action.payload,
      };
    }
    default:
      return { ...localState };
  }
};
